export default __webpack_public_path__ + "static/media/dav.67c53232.jpg";